var map = {
	"./emoji-agenda.svg": 1055,
	"./emoji-box.svg": 1056,
	"./emoji-camera.svg": 1057,
	"./emoji-capsule.svg": 1058,
	"./emoji-chat.svg": 1059,
	"./emoji-done.svg": 1060,
	"./emoji-facebook.svg": 1061,
	"./emoji-france.svg": 1062,
	"./emoji-grec.svg": 1063,
	"./emoji-instagram.svg": 1064,
	"./emoji-lampe.svg": 1065,
	"./emoji-laptop.svg": 1066,
	"./emoji-linkedin.svg": 1067,
	"./emoji-maroc.svg": 1068,
	"./emoji-messagerie.svg": 1069,
	"./emoji-money.svg": 1070,
	"./emoji-money2.svg": 1071,
	"./emoji-pen.svg": 1072,
	"./emoji-point.svg": 1073,
	"./emoji-smile.svg": 1074,
	"./emoji-smileSick.svg": 1075,
	"./emoji-stats.svg": 1076,
	"./emoji-tick.svg": 1077,
	"./emoji-write.svg": 1078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1054;